import ServiceLayout from "../components/ServiceLayout";

export default function WebDevelopment(){
  return(
    <ServiceLayout
      title="Web Development"
      subtitle="Scalable and modern websites for growing businesses."
      gradient="linear-gradient(135deg,#ff7a18,#ffb347)"
      features={[
        "Responsive Design",
        "SEO Optimization",
        "Performance Tuning",
        "Security Implementation",
        "Cloud Deployment",
        "API Integration"
      ]}
    />
  );
}
